<template>
  <section
    ref="scrollContainer"
    :class="['section', 'section--portfolio']"
    @scroll="handleScroll"
  >
    <!-- Full-width Fixed Header Navbar -->
    <div :class="['portfolio-navbar', { 'is-scrolled': isScrolled }]">
      <div class="navbar-back" @click="$router.push('/portfolio')">
        <span class="back-arrow">‹</span>
        <span class="back-text">BACK</span>
      </div>
      <div class="navbar-title">
        {{ portfolioDetails.title }}
      </div>
    </div>

    <!-- Top Visual Section -->
    <div
      v-if="portfolioDetails.image && portfolioDetails.image.path"
      ref="visual"
      class="portfolio-visual"
    >
      <progressive-background :src="portfolioDetails.image.path" />
      <div class="portfolio-visual-overlay"></div>
      <!-- Left-vCenter Content Container -->
      <div class="portfolio-visual-content">
        <h1 class="portfolio-item-title">{{ portfolioDetails.title }}</h1>
        <div
          v-if="portfolioDetails.description"
          class="portfolio-item-subtitle"
          v-html="portfolioDetails.description"
        ></div>
      </div>
    </div>

    <!-- Loading State -->
    <div v-else class="portfolio-visual" style="background: #111;">
      <div class="portfolio-visual-content">
        <h1 class="portfolio-item-title">Loading...</h1>
      </div>
    </div>

    <!-- Portfolio Main Content -->
    <div class="portfolio-item">
      <div class="wrapper">
        <div class="content">
          <div class="portfolio-item-info">
            <div class="portfolio-info-col">
              <h3 class="portfolio-info-title">Work</h3>
              <div v-html="portfolioDetails.work"></div>
            </div>
            <div class="portfolio-info-col">
              <h3 class="portfolio-info-title">Project</h3>
              <div v-html="portfolioDetails.project"></div>
            </div>
            <div class="portfolio-info-col">
              <h3 class="portfolio-info-title">Designers</h3>
              <div v-html="portfolioDetails.designers"></div>
            </div>
          </div>
          <div class="portfolio-text-content" v-html="portfolioDetails.content"></div>
        </div>
        <Footer />
      </div>
    </div>
  </section>
</template>

<script>
import store from '@/store';
import { mapActions } from 'vuex';
import Footer from '@/components/UI/Footer';

export default {
  components: {
    Footer,
  },
  data() {
    return {
      isScrolled: false,
      portfolioDetails: {
        title: '',
        description: '',
        work: '',
        project: '',
        designers: '',
        content: '',
        image: {
          path: '',
        },
      },
    };
  },
  beforeRouteEnter({ params: { id } }, from, next) {
    store.dispatch('portfolio/portfolioDetails:fetch', id)
      .then((response) => {
        next((vm) => {
          const { content, ...restDetails } = response;
          /* eslint no-param-reassign: ["error", { "props": false }] */
          vm.portfolioDetails = { ...restDetails, content };
        });
      }).catch(next);
  },
  methods: {
    ...mapActions({ fetchPortfolioDetails: 'portfolio/portfolioDetails:fetch' }),
    handleScroll(event) {
      const { scrollTop } = event.target;
      const visualHeight = this.$refs.visual ? this.$refs.visual.clientHeight : window.innerHeight;
      // Toggle navbar background and title fade-in at ~40% visual image scroll
      this.isScrolled = scrollTop > visualHeight * 0.4;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/PortfolioDetails.vue